import { useState } from "react";
import { Link } from "react-router-dom";

import { useDebouncedValue } from "../lib/hooks";
import { trpc } from "../trpc";

export function TermSearch({
  placeholder = "Search a word — e.g. Divyadrishti, Prakriti…",
  autoFocus = false,
}: {
  placeholder?: string;
  autoFocus?: boolean;
}) {
  const [query, setQuery] = useState("");
  const debounced = useDebouncedValue(query.trim());
  const enabled = debounced.length > 0;
  const results = trpc.glossary.search.useQuery(
    { q: debounced, limit: 24 },
    { enabled },
  );

  return (
    <div className="relative">
      <div className="flex items-center gap-3 rounded-2xl border border-line-strong bg-paper-raised px-5 py-3.5 shadow-sm transition focus-within:border-terracotta/60">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          className="text-ink-faint"
          aria-hidden
        >
          <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
          <path
            d="m20 20-3-3"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
        <input
          type="search"
          value={query}
          autoFocus={autoFocus}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={placeholder}
          className="w-full bg-transparent font-serif text-lg text-ink outline-none placeholder:text-ink-faint/70"
          aria-label="Search glossary"
        />
      </div>

      {enabled ? (
        <div className="mt-3 overflow-hidden rounded-2xl border border-line bg-paper-raised">
          {results.isLoading ? (
            <p className="px-5 py-4 text-sm text-ink-faint">Searching…</p>
          ) : results.data && results.data.length > 0 ? (
            <ul className="divide-y divide-line">
              {results.data.map((term) => (
                <li key={term.slug}>
                  <Link
                    to={`/glossary/${term.slug}`}
                    className="flex items-center justify-between px-5 py-3 transition-colors hover:bg-paper-sunk"
                  >
                    <span className="font-serif text-lg text-ink">
                      {term.displayName}
                    </span>
                    {term.isStub ? (
                      <span className="eyebrow text-ink-faint/70">
                        unwritten
                      </span>
                    ) : null}
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <p className="px-5 py-4 text-sm text-ink-faint">
              No word matches “{debounced}”.
            </p>
          )}
        </div>
      ) : null}
    </div>
  );
}
